import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DatumFormatPipe} from '../../../pipes/datum-format.pipe';

@Component({
    selector: 'app-appointment-details',
    templateUrl: './appointment-details.component.html',
    styleUrls: ['./appointment-details.component.scss']
})
export class AppointmentDetailsComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<AppointmentDetailsComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private _datumFormatPipe: DatumFormatPipe) {

    }

    ngOnInit(): void {

    }

    closeDialog() {
        this.dialogRef.close(null);
    }

    getTimeString(value: Date): string {
        return this._datumFormatPipe.transformOnlyTime(value);
    }
}
